import { Types } from './types'
const initialState = {
    dataImageProduct: {
        rows: [],
        paging: {}
    },
}

const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_IMAGE_PRODUCT:
            return {
                ...newState,
                dataImageProduct: action.payload
            }
        default:
            return newState
    }
}

export default reducer